<div class="app-shell">

  <!-- Toggle (mobile) -->
  <button class="app-hamburger d-lg-none" type="button" (click)="toggleNav()" aria-label="Abrir menu">
    <i class="fe fe-menu"></i>
  </button>

  <!-- Backdrop (mobile) -->
  @if (navOpen()) {
    <div class="app-backdrop d-lg-none" (click)="closeNav()"></div>
  }

  <!-- ============ COLUNA ESQUERDA: brand + sidebar ============ -->
  <aside class="app-aside" [class.app-aside--open]="navOpen()" [class.app-aside--collapsed]="collapsed()">

    <!-- Brand -->
    <a class="app-brand" [routerLink]="['/', tenant(), 'ocorrencias']" (click)="closeNav()">
      <span class="brand-logo">
        <svg width="38" height="38" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <rect width="40" height="40" rx="11" fill="url(#etBrandGrad)" />
          <g transform="rotate(-18 20 20)">
            <rect x="8" y="15.5" width="24" height="9" rx="2.6" fill="#ffffff" />
            <circle cx="15" cy="15.5" r="1.3" fill="url(#etBrandGrad)" />
            <circle cx="15" cy="24.5" r="1.3" fill="url(#etBrandGrad)" />
            <line x1="15" y1="17" x2="15" y2="23" stroke="url(#etBrandGrad)" stroke-width="0.9"
              stroke-dasharray="1 1.4" stroke-linecap="round" />
          </g>
          <defs>
            <linearGradient id="etBrandGrad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
              <stop stop-color="#1c3a5e" />
              <stop offset="1" stop-color="#12263f" />
            </linearGradient>
          </defs>
        </svg>
      </span>
      <span class="brand-name">
        <span class="brand-wordmark">e<strong>Trace</strong></span>
        <!-- A assinatura é parte do nome, não um slogan à parte: é assim que a marca se
             apresenta no documento da GBT. -->
        <span class="brand-tagline">Integrated Management & Compliance</span>
      </span>
    </a>

    <!-- Sidebar -->
    <nav class="app-sidebar" id="sidebar">

      <!-- Navegação -->
      <div class="app-nav">
        <ul class="navbar-nav">
          @for (item of mainNav(); track item.path) {
            <li class="nav-item">
              <a class="nav-link" [routerLink]="['/', tenant(), item.path]" routerLinkActive="active" (click)="closeNav()" [attr.title]="collapsed() ? item.label : null">
                <i class="fe {{ item.icon }}"></i> <span class="nav-label">{{ item.label }}</span>
              </a>
            </li>
          }
        </ul>

        @if (systemNav().length) {
          <hr class="navbar-divider my-3" />

          <h6 class="navbar-heading">Sistema</h6>
          <ul class="navbar-nav">
            @for (item of systemNav(); track item.path) {
              <li class="nav-item">
                <a class="nav-link" [routerLink]="['/', tenant(), item.path]" routerLinkActive="active" (click)="closeNav()" [attr.title]="collapsed() ? item.label : null">
                  <i class="fe {{ item.icon }}"></i> <span class="nav-label">{{ item.label }}</span>
                </a>
              </li>
            }
          </ul>
        }
      </div>

      <!-- Rodapé da sidebar: versão e ano do sistema -->
      <div class="app-sidebar-version">
        <span>eTrace · v{{ version }}</span>
        <span>© {{ year }}</span>
      </div>
    </nav>

    <!-- Toggle encolher/expandir (bloco próprio, desktop) -->
    <button
      class="app-collapse-block d-none d-lg-flex"
      type="button"
      (click)="toggleCollapse()"
      [attr.aria-label]="collapsed() ? 'Expandir menu' : 'Encolher menu'"
      [title]="collapsed() ? 'Expandir' : 'Encolher'"
    >
      <i class="fe" [class.fe-chevrons-left]="!collapsed()" [class.fe-chevrons-right]="collapsed()"></i>
    </button>

    <!-- Rodapé (bloco flutuante): linha de ações + utilizador -->
    <div class="app-sidebar-foot">

      <!-- Linha de cima: notificações, busca e alternância de tema -->
      <div class="app-foot-actions">
        <div class="notif-wrap">
          <button
            class="app-icon-btn"
            type="button"
            aria-label="Notificações"
            title="Notificações"
            [attr.aria-expanded]="notifOpen()"
            aria-controls="notif-drawer"
            (click)="toggleNotif($event)"
          >
            <i class="fe fe-bell"></i>
            @if (unread() > 0) {
              <span class="notif-badge">{{ unread() > 9 ? '9+' : unread() }}</span>
            }
          </button>
        </div>
        <button class="app-icon-btn" type="button" aria-label="Procurar" title="Procurar (Ctrl+K)" (click)="openSearch()">
          <i class="fe fe-search"></i>
        </button>
        <button
          class="app-icon-btn"
          type="button"
          [attr.aria-label]="darkMode() ? 'Tema claro' : 'Tema escuro'"
          [title]="darkMode() ? 'Tema claro' : 'Tema escuro'"
          (click)="toggleDarkMode()"
        >
          <i class="fe" [class.fe-moon]="!darkMode()" [class.fe-sun]="darkMode()"></i>
        </button>
      </div>

      <!-- Linha de baixo: utilizador (foto + nome + e-mail) -->
      <div class="app-user" [class.show]="userMenuOpen()">
        <button class="app-user-toggle" type="button" (click)="toggleUser($event)" [attr.aria-expanded]="userMenuOpen()">
          <span class="avatar avatar-sm avatar-online">
            <img src="assets/img/avatars/profiles/avatar-1.jpg" class="avatar-img rounded-circle" alt="Utilizador" />
          </span>
          <span class="app-user-meta">
            <span class="app-user-name">{{ userName() }}</span>
            <span class="app-user-email">{{ userEmail() }}</span>
          </span>
          <i class="fe fe-chevron-up app-user-caret"></i>
        </button>
        <div class="dropdown-menu" [class.show]="userMenuOpen()">
          <a class="dropdown-item" href="#" (click)="openPasswordDialog($event)">
            <i class="fe fe-lock me-2"></i> Alterar palavra-passe
          </a>
          <a class="dropdown-item text-danger" href="#" (click)="logout($event)">
            <i class="fe fe-log-out me-2"></i> Sair
          </a>
        </div>
      </div>
    </div>
  </aside>

  <!-- ============ CONTEÚDO ============ -->
  <main class="app-content">
    <div class="route-view">
      <router-outlet />
    </div>
  </main>

  <!-- Notificações — painel lateral. Vive aqui e não junto ao sino porque a sidebar ganha
       transform no mobile, e um elemento fixed dentro de um ancestral transformado deixa de
       se colar ao ecrã. -->
  @if (notifOpen()) {
    <div
      class="notif-drawer-backdrop"
      animate.enter="app-fade-in"
      animate.leave="app-fade-out"
      (click)="closeNotif()"
    ></div>
    <aside
      class="notif-drawer"
      id="notif-drawer"
      role="dialog"
      aria-modal="true"
      aria-label="Notificações"
      animate.enter="app-slide-in-right"
      animate.leave="app-slide-out-right"
      (click)="$event.stopPropagation()"
    >
      <header class="notif-drawer-head">
        <div class="notif-drawer-title">
          <i class="fe fe-bell"></i>
          <span>Notificações</span>
          @if (unread() > 0) {
            <span class="notif-drawer-count">{{ unread() }}</span>
          }
        </div>
        <button class="notif-drawer-close" type="button" aria-label="Fechar" (click)="closeNotif()">
          <i class="fe fe-x"></i>
        </button>
      </header>

      @if (unread() > 0) {
        <div class="notif-drawer-actions">
          <button class="notif-mark-all" type="button" (click)="markAllNotificationsRead($event)">
            <i class="fe fe-check-circle me-1"></i>Marcar todas como lidas
          </button>
        </div>
      }

      <div class="notif-drawer-body">
        @for (n of notifications(); track n.id) {
          <button class="notif-item" [class.unread]="!n.read" type="button" (click)="openNotification(n)">
            <span class="notif-item-icon"><i class="fe {{ notifIcon(n.type) }}"></i></span>
            <span class="notif-item-main">
              <span class="notif-item-title">{{ n.title }}</span>
              @if (n.body) { <span class="notif-item-body">{{ n.body }}</span> }
              <span class="notif-item-time">{{ n.createdAt | date: 'dd/MM HH:mm' }}</span>
            </span>
            @if (!n.read) { <span class="notif-item-dot"></span> }
          </button>
        } @empty {
          <div class="notif-empty">
            <span class="notif-empty-icon"><i class="fe fe-inbox"></i></span>
            <p class="notif-empty-title">Sem notificações</p>
            <p class="notif-empty-text">
              Avisamos aqui quando uma participação entrar, um estado mudar ou um prazo estiver a chegar.
            </p>
          </div>
        }
      </div>
    </aside>
  }

  <!-- Busca global (command palette) -->
  @if (searchOpen()) {
    <app-global-search (close)="closeSearch()" />
  }

  <!-- Confirmações das ações que gravam -->
  @if (passwordDialogOpen()) {
  <app-change-password-dialog (close)="passwordDialogOpen.set(false)" />
}

<app-toast-host />
</div>
